__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-doc-communications-root'].baseUrl;
import './iguazu-rpc/config';
import './iguazu-rest/config';
import ModuleContainer from './components/CommunicationsRoot';
import memberProducts from './products';
memberProducts();
if (!global.BROWSER) {
  // eslint-disable-next-line n/global-require -- Including this in client-side bundle is security risk
  const buildContentSecurityPolicy = require('@americanexpress/content-security-policy').default;
  ModuleContainer.onHolocronLoadValidationConfig = {
    // this is required for One App to accept the provided CSP
    provideFullCsp: true,
    csp: buildContentSecurityPolicy({
      // This will have any CSP violations reported back to your One App v4 server
      reportUri: `${process.env.AXP_CLIENT_REPORTING_URL}/report/security/csp-violation`,
      directiveAdditions: {
        // Add any tenant required additions to the basic American Express CSP
        imgSrc: ['blob:'],
        connectSrc: ['blob:']
      }
    })
  };
}
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
  providedExternals: {
    '@americanexpress/react-ddl': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.3.2',
      module: require('@americanexpress/react-ddl')
    },
    '@americanexpress/product-ducks': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.6.0',
      module: require('@americanexpress/product-ducks')
    },
    '@americanexpress/one-app-module-wrapper': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '3.5.0',
      module: require('@americanexpress/one-app-module-wrapper')
    },
    'iguazu': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '3.2.0',
      module: require('iguazu')
    },
    'iguazu-rest': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.11.1',
      module: require('iguazu-rest')
    },
    'iguazu-graphql': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.3.0',
      module: require('iguazu-graphql')
    },
    'iguazu-holocron': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.7.0',
      module: require('iguazu-holocron')
    },
    'iguazu-rpc': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.6.1',
      module: require('iguazu-rpc')
    },
    'react-intl': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '6.8.9',
      module: require('react-intl')
    }
  }
});
if (global.getTenantRootModule === undefined || global.rootModuleName && global.rootModuleName === 'axp-doc-communications-root') {
  global.getTenantRootModule = () => ModuleContainer;
  global.rootModuleName = 'axp-doc-communications-root';
}